import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

switch (environment.name) {
  case "PRODUCTION":
  case "TESTING":
    enableProdMode();
    break;
  case "DEVELOPMENT":
    //do nothing
    break;
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
